import {Route, Routes} from '@angular/router';
import {initialDataResolver} from 'app/app.resolvers';
import {AuthGuard} from 'app/core/auth/guards/auth.guard';
import {NoAuthGuard} from 'app/core/auth/guards/noAuth.guard';
import {LayoutComponent} from 'app/layout/layout.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    {path: '', pathMatch : 'full', redirectTo: 'dashboards'},
    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'dashboards'},

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes')},
            {path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes')},
            {path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes')},
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes')},
            {path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes')},
            {path: 'setup-password', loadChildren: () => import('app/modules/auth/setup-password/setup-password.routes')}
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes')},
            {path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes')}
        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            {path: 'dashboards', children: [
                {path: 'overview', loadChildren: () => import('app/modules/admin/dashboards/overview/overview.routes')},
            ]},
            {path: 'companies', children: [
                {path: '', loadChildren: () => import('app/modules/admin/companies/companies.routes')},
            ]},
            {path: 'offers', children: [
                {path: '', loadChildren: () => import('app/modules/admin/offers/offers.routes')},
            ]},
            {path: 'services', children: [
                    {path: '', loadChildren: () => import('app/modules/admin/services/services.routes')},
            ]},
            {path: 'suggestions', children: [
                    {path: '', loadChildren: () => import('app/modules/admin/suggestions/suggestions.routes')},
            ]},
            {path: 'news', children: [
                    {path: '', loadChildren: () => import('app/modules/admin/news/news.routes')},
            ]},
            {path: 'users', children: [
                    {path: '', loadChildren: () => import('app/modules/admin/users/users.routes')},
            ]},
            {path: 'staff', children: [
                {path: '', loadChildren: () => import('app/modules/admin/staff/staff.routes')},
            ]},
            { path: 'websites', children: [
                {path: '', loadChildren: () => import('app/modules/admin/websites/websites.routes')},
            ]},
            {path: 'payments', children: [
                {path: '', loadChildren: ()=> import('app/modules/admin/payments/orders/orders.routes')},
            ]},
            {path: 'credits', children: [
                {path: '', loadChildren: ()=> import('app/modules/admin/payments/credits/credits.routes')}
            ]},
            {path: 'operations', children: [
                {path: '', loadChildren: ()=> import('app/modules/admin/payments/orders/orders.routes')},
                {path: 'credits', loadChildren: ()=> import('app/modules/admin/payments/credits/credits.routes')},
            ]},
            {path: 'mails', children: [
                    {path: '', loadChildren: ()=> import('app/modules/admin/mails/mails.routes')}
            ]},
            {
                path: 'front-app', children: [
                    {path: '', loadChildren: () => import('app/modules/admin/front-app/front-app.routes')}
                    ]
            },
            {
                path: 'subscriptions', children: [
                    {path: '', loadChildren: () => import('app/modules/admin/subscriptions/subscriptions.routes')}
                ]
            },
            {
                path: 'logs', children: [
                    {path: '', loadChildren: () => import('app/modules/admin/logs/logs.routes')}
                ]
            },
            {
                path: 'queues', children: [
                    {path: '', loadChildren: () => import('app/modules/admin/queue/queue.routes')}
                ]
            },
            {
                path: 'sla-config', children: [
                    {path: '', loadChildren: () => import('app/modules/admin/sla-config/sla-config.routes')}
                ]
            },
            {
                path: 'operations/dashboard', children: [
                    {path: '', loadChildren: () => import('app/modules/admin/operations-dashboard/operations-dashboard.routes')}
                ]
            },
            {
                path: 'service-mapping', children: [
                    {path: '', loadChildren: () => import('app/modules/admin/service-mapping/service-mapping.routes')}
                ]
            }
        ]
    }
] as Routes;
